import { Component, OnInit, Input } from '@angular/core';
import { CreditCard } from '../../../lib/lib';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent implements OnInit {

  @Input()
  cards: CreditCard[];

  constructor() { }

  ngOnInit() {
  }

}
